/* eslint-disable */
import Long from 'long';
import _m0 from 'protobufjs/minimal';
const baseMentionData = { name: '', slug: '' };
export const MentionData = {
    fromJSON(object) {
        const message = Object.assign({}, baseMentionData);
        message.name = object.name !== undefined && object.name !== null ? String(object.name) : '';
        message.slug = object.slug !== undefined && object.slug !== null ? String(object.slug) : '';
        message.id = object.id !== undefined && object.id !== null ? String(object.id) : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.name !== undefined && (obj.name = message.name);
        message.slug !== undefined && (obj.slug = message.slug);
        message.id !== undefined && (obj.id = message.id);
        return obj;
    },
};
if (_m0.util.Long !== Long) {
    _m0.util.Long = Long;
    _m0.configure();
}
//# sourceMappingURL=decoration_mention.js.map